import useLocalStorage from '@/hooks/useLocalStorage';
import { Photocard } from '@/types/photocard';
import { getPrice } from '@/utils/getPrice';
import { Image } from '@/components/Image';

interface IProps {
  photocard: Photocard;
  onClick: () => void;
}

export const PhotocardItem = ({ photocard, onClick }: IProps) => {
  const [currency] = useLocalStorage('currency', null);
  return (
    <div className="w-[156px] h-[301px] flex flex-col cursor-pointer" onClick={onClick}>
      <Image src={photocard.image} alt="photocard" className="w-full aspect-[156/242] rounded-[12px] object-cover" width={156} />
      <span className="text-[14px] leading-5 font-medium mt-[12px] text-[#4D4D4D] truncate">{photocard.name_en}</span>
      <span className="text-[16px] font-bold mt-[2px]">{getPrice(photocard.offer.price, currency)}</span>
    </div>
  );
};

export default PhotocardItem;
